import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const ServiceStore = {
  namespaced: true,
  state: {
    services: [],
    servicesInWorkOrder: [],
    service: null
  },
  getters,
  mutations,
  actions
}

export default ServiceStore
